import { render } from "./ListeTransfertPage.vue?vue&type=template&id=5c205d92&ts=true"
import script from "./ListeTransfertPage.vue?vue&type=script&lang=ts"
export * from "./ListeTransfertPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__